import { DraftConfiguration, View } from '@/types';
import { getIsConfigurationOnView } from '@/model/configuration/getIsConfigurationOnView';

export const getConfigurationsOnView = (configurations: DraftConfiguration[], view: View) =>
  configurations.filter((configuration) => getIsConfigurationOnView(configuration, view));
